import React from 'react';
import { AppContext } from '../../context/AppContext/context';

function useAppointmentFormOpen() {
  const { state, dispatch } = React.useContext(AppContext);

  const isOpenRef = React.useRef(state.isNewAppointmentFormOpen);

  const set = React.useCallback(
    (payload: boolean | ((prev: boolean) => boolean)) => {
      const newIsOpen =
        typeof payload === 'function' ? payload(isOpenRef.current) : payload;
      isOpenRef.current = newIsOpen;
      dispatch({
        type: 'SET_IS_NEW_APPOINTMENT_FORM_OPEN',
        payload: newIsOpen,
      });
    },
    [dispatch],
  );

  return [state.isNewAppointmentFormOpen, set] as const;
}

export default useAppointmentFormOpen;
